import React, { useState, useEffect } from "react";

import Tab from "./Tab";

const ButtonTabbar = ({
  onChange,
  options = [],
  defaultSelected,
  selected,
}) => {
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (selected) {
      const _selected = options.find((item) => item.value === selected?.value);

      if (_selected) {
        setActiveTab(_selected);
      }
    } else {
      if (!activeTab && defaultSelected) {
        const _selected = options.find(
          (item) => item.value === defaultSelected.value
        );

        if (_selected) {
          setActiveTab(_selected);
        }
      }
    }
  }, [defaultSelected, selected]);

  const handlePress = (selectedTab) => {
    setActiveTab(selectedTab);

    if (onChange) {
      onChange(selectedTab);
    }
  };

  return (
    <div className="d-flex">
      {options.map((item) => {
        return (
          <Tab
            onPress={() => handlePress(item)}
            selected={activeTab?.value === item.value}
            key={item.value}
          >
            {item.label}
          </Tab>
        );
      })}
    </div>
  );
};

export default ButtonTabbar;
